import { jsx as _jsx } from "react/jsx-runtime";
import { TypographyText } from '../_core';
import styles from '../typography.module.css';
const SIZE_CLASS = {
    lg: styles['label-lg'],
    md: styles['label-md'],
    sm: styles['label-sm'],
};
const COLOR_VAR = {
    foreground: undefined,
    mute: 'var(--muted-foreground)',
    primary: 'var(--primary)',
    destructive: 'var(--destructive)',
    success: 'var(--success)',
    warning: 'var(--warning-ink)',
};
/**
 * Label text. ALWAYS renders `<span>` — never the HTML `<label>` element.
 *
 * Form-label semantics come exclusively through `<Field label="...">`.
 * Use `<Label>` for visual labeling in tab labels, button text, and UI
 * chrome — not for associating form controls.
 *
 * lg=md=14 (sans 600, DEFAULT), sm=12 (sans 600). Sizes lg and md visually
 * collapse onto the same `label` tier in the 7-tier scale.
 *
 * Do not override fontSize, fontFamily, lineHeight, fontWeight, or
 * letterSpacing via style prop.
 */
export function Label({ size = 'md', color = 'foreground', children, style, ...rest }) {
    return (_jsx(TypographyText, { as: "span", roleClassName: SIZE_CLASS[size], color: COLOR_VAR[color], style: style, ...rest, children: children }));
}
//# sourceMappingURL=Label.js.map